module.exports = __webpack_public_path__ + "img/10_BC11_start_a_squirrel.5d70e319.jpg";